if (!customElements.get('ns-cart-discount')) customElements.define('ns-cart-discount', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.querySelector('button').addEventListener('click', () => this.apply());
    this.querySelector('input').addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); this.apply(); } });
  }
  async apply() {
    const input = this.querySelector('input'), button = this.querySelector('button'), status = this.querySelector('[role=status]'), code = input.value.trim();
    if (!code || button.disabled) { if (!code) input.focus(); return; }
    button.disabled = true; this.setAttribute('aria-busy', 'true'); status.textContent = '';
    const root = window.Shopify.routes.root;
    try {
      const beforeResponse = await fetch(root + 'cart.js');
      if (!beforeResponse.ok) throw new Error('cart');
      const before = await beforeResponse.json();
      const previous = (before.discount_codes || []).filter(d => d.applicable).map(d => d.code);
      const codes = [...new Set([...previous, code])];
      const sections = []; document.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { detail: { sections } }));
      const response = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type':'application/json' }, body: JSON.stringify({ discount: codes.join(','), sections, sections_url: location.pathname }) });
      if (!response.ok) throw new Error('discount');
      const cart = await response.json();
      const applied = (cart.discount_codes || []).some(d => d.applicable && d.code.toLowerCase() === code.toLowerCase()) || (cart.cart_level_discount_applications || []).some(d => d.type === 'discount_code' && d.title.toLowerCase() === code.toLowerCase()) || cart.items.some(i => (i.discounts || []).some(d => d.title.toLowerCase() === code.toLowerCase()));
      if (!applied) { status.textContent = this.dataset.invalid; return; }
      if (document.querySelector('.ns-cart-page')) { location.reload(); return; }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles:true, detail:{ baseEvent:'discount:update', cart } }));
      const message = this.dataset.success;
      requestAnimationFrame(() => { const newStatus = document.querySelector('#cart-drawer ns-cart-discount [role=status]'); if (newStatus) newStatus.textContent = message; });
    } catch { status.textContent = this.dataset.error; }
    finally { button.disabled = false; this.removeAttribute('aria-busy'); }
  }
});
